(() => {
  const MEDIA_ROOT_SELECTOR = 'main#MainContent[data-template="product"] .product-information__media';
  const PRODUCT_MAIN_SELECTOR = 'main#MainContent[data-template="product"]';
  const ENTER_CLASS = 'pdp-media-enter';

  /** @type {HTMLElement | null} */
  let activeMain = null;

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function isZoomOpen() {
    return Boolean(
      document.querySelector(`${PRODUCT_MAIN_SELECTOR} zoom-dialog dialog[open]`)
    );
  }

  /**
   * @param {ParentNode} root
   * @returns {HTMLElement | null}
   */
  function getActiveMediaElement(root) {
    const visibleSlide = root.querySelector('slideshow-slide[aria-hidden="false"]');
    if (visibleSlide) {
      return visibleSlide.querySelector('.product-media');
    }

    const gridItem = root.querySelector('.media-gallery__grid .product-media-container');
    return gridItem?.querySelector('.product-media') ?? null;
  }

  /**
   * @param {HTMLElement} mediaEl
   */
  function animateMedia(mediaEl) {
    if (prefersReducedMotion()) return;

    mediaEl.classList.remove(ENTER_CLASS);
    void mediaEl.offsetWidth;
    mediaEl.classList.add(ENTER_CLASS);
    mediaEl.style.willChange = 'transform, opacity';

    const cleanup = () => {
      mediaEl.classList.remove(ENTER_CLASS);
      mediaEl.style.willChange = '';
    };

    mediaEl.addEventListener('animationend', cleanup, { once: true });
  }

  /**
   * @param {ParentNode} root
   */
  function scheduleAnimate(root) {
    if (isZoomOpen()) return;

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        const mediaEl = getActiveMediaElement(root);
        if (mediaEl instanceof HTMLElement) {
          animateMedia(mediaEl);
        }
      });
    });
  }

  /**
   * @param {Event} event
   */
  function handleSlideshowSelect(event) {
    if (!(event instanceof CustomEvent) || !event.detail) return;

    const mediaRoot = document.querySelector(MEDIA_ROOT_SELECTOR);
    if (!mediaRoot || !mediaRoot.contains(event.target)) return;

    const { index, previousIndex } = event.detail;
    if (typeof index !== 'number' || index === previousIndex) return;

    scheduleAnimate(mediaRoot);
  }

  function init() {
    const productMain = document.querySelector(PRODUCT_MAIN_SELECTOR);
    if (!productMain || productMain === activeMain) return;

    activeMain = productMain;
    productMain.addEventListener('slideshow:select', handleSlideshowSelect);
  }

  function boot() {
    activeMain = null;
    init();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
